import { getLeftMenu } from "@/views/zhiji/js/services/service.js";

// eslint-disable-next-line
export default module = {
    state: {
        menuList: [],
        current: ""
    },
    mutations: {
        leftMenuChange(state, menuList) {
            state.menuList.splice(0, state.menuList.length, ...menuList);
        },
        currentChange(state, currentMenu) {
            state.current = currentMenu;
        }
    },
    actions: {
        initLeftMenu(context) {
            context.commit("currentChange", window.location.hash.slice(1));

            getLeftMenu().then(function(menuList) {
                context.commit("leftMenuChange", menuList);
            });
        }
    }
};
